var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddToSamplesBasketHovered(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4327 16.25H3.57271C2.54589 16.2505 1.64074 15.5588 1.34712 14.5492C1.0535 13.5396 1.44117 12.4521 2.30033 11.8751L8.76636 7.52673L10.4845 6.31159C11.28 5.75834 11.3974 5.20418 11.3974 4.9239C11.3974 4.25654 10.8831 3.68959 10.2736 3.68685H10.2674C9.65956 3.68498 9.15989 4.17827 9.13829 4.80157C9.13002 5.01358 9.01215 5.20496 8.82907 5.30362C8.646 5.40228 8.42553 5.39323 8.25072 5.27988C8.07591 5.16653 7.97331 4.9661 7.98157 4.75409C8.02574 3.49325 9.0369 2.49575 10.2665 2.50001H10.279C11.5327 2.5064 12.5533 3.59556 12.5533 4.9239C12.5533 5.43881 12.37 6.43302 11.1367 7.29119L9.41768 8.50816L9.40611 8.51546L2.93474 12.8721C2.50736 13.1628 2.31556 13.7061 2.46234 14.2102C2.60912 14.7143 3.05995 15.0606 3.57271 15.0632H16.4327C16.9456 15.061 17.3968 14.7148 17.5438 14.2106C17.6909 13.7064 17.4991 13.1629 17.0716 12.8721L11.2604 8.96372C10.9955 8.78309 10.9225 8.4169 11.0969 8.14403C11.2714 7.87116 11.6278 7.79401 11.8948 7.97134L17.7051 11.8788C18.5608 12.457 18.9459 13.5424 18.6527 14.5497C18.3595 15.5571 17.4573 16.248 16.4327 16.25Z",
    fill: "#00C795"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 1.25H16.25V3.125L14.375 3.125V4.375H16.25V6.25H17.5V4.375H19.375V3.125L17.5 3.125V1.25Z",
    fill: "#00C795"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToSamplesBasketHovered);
export default __webpack_public_path__ + "static/media/addToSamplesBasketHovered.49839366.svg";
export { ForwardRef as ReactComponent };